import _classCallCheck from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/gianfaye/Repo/gianfaye.github.com/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepExtend } from "tsparticles-engine";
export var Trail = /*#__PURE__*/function () {
  function Trail() {
    _classCallCheck(this, Trail);
    this.delay = 1;
    this.pauseOnStop = false;
    this.quantity = 1;
  }
  _createClass(Trail, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.delay !== undefined) {
        this.delay = data.delay;
      }
      if (data.quantity !== undefined) {
        this.quantity = data.quantity;
      }
      if (data.particles !== undefined) {
        this.particles = deepExtend({}, data.particles);
      }
      if (data.pauseOnStop !== undefined) {
        this.pauseOnStop = data.pauseOnStop;
      }
    }
  }]);
  return Trail;
}();